export type ThemeId = 'mint' | 'navy' | 'ocean';

export const THEMES: Array<{ id: ThemeId; label: string; description: string }> = [
  { id: 'mint', label: 'Mint Fresh', description: 'Clean light mint workspace' },
  { id: 'navy', label: 'Navy', description: 'Deep blue professional terminal' },
  { id: 'ocean', label: 'Ocean', description: 'Balanced blue-teal market view' },
];
